module.exports = __webpack_public_path__ + "media/fail_pegman.3b77f5ac.mp3";